// extracted by mini-css-extract-plugin
export default {"shoptetInstructionItem":"UploadProducts_shoptetInstructionItem__gqnkw","tooltipIcon":"UploadProducts_tooltipIcon__63Vgw","imgBox":"UploadProducts_imgBox__ZolF2"};